"use client";
import React from "react";
import * as reactEmotion from "@emotion/react";
export function GlobalStyles(props) {
    const { styles } = props;
    return React.createElement(reactEmotion.Global, { styles: reactEmotion.css(styles) });
}
